<template>
  <div class="flex items-center justify-between">
    <div class="flex items-center space-x-3">
      <span 
        class="status-indicator text-sm"
        :class="statusClasses(device.status)"
      >
        <span class="pulse-dot mr-1"></span>
        {{ device.status.toUpperCase() }}
      </span>
      <span class="text-sm text-gray-500">
        {{ formatLastSeen(device.lastSeen) }}
      </span>
    </div>
    <div class="text-right text-sm text-gray-500">
      <div>v{{ device.shadow?.reported?.firmware || '1.0.0' }}</div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  device: {
    type: Object,
    required: true
  }
})

const statusClasses = (status) => {
  switch (status) {
    case 'online':
      return 'status-online'
    case 'offline':
      return 'status-offline'
    case 'reconnecting':
      return 'status-reconnecting'
    default:
      return 'bg-gray-100 text-gray-800'
  }
}

const formatLastSeen = (lastSeen) => {
  if (!lastSeen) return 'Never seen'
  
  const now = new Date()
  const seen = new Date(lastSeen)
  const diffMs = now - seen
  const diffSecs = Math.floor(diffMs / 1000)
  
  if (diffSecs < 30) return 'Just now'
  if (diffSecs < 60) return `${diffSecs}s ago`
  if (diffSecs < 3600) return `${Math.floor(diffSecs / 60)}m ago`
  
  return seen.toLocaleString()
}
</script>

<style scoped>
.status-indicator {
  @apply inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium;
}

.status-online {
  @apply bg-green-100 text-green-800;
}

.status-offline {
  @apply bg-red-100 text-red-800;
}

.status-reconnecting {
  @apply bg-yellow-100 text-yellow-800;
}

.pulse-dot {
  @apply inline-block w-1.5 h-1.5 rounded-full;
}

.status-online .pulse-dot {
  @apply bg-green-400 animate-pulse;
}

.status-offline .pulse-dot {
  @apply bg-red-400;
}

.status-reconnecting .pulse-dot {
  @apply bg-yellow-400 animate-pulse;
}
</style>